import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import axios from 'axios';
import {ConfigProvider} from 'antd';
import {PRIMARY_COLOR} from "./util/Colors";

ConfigProvider.config({
    theme: {
        primaryColor: PRIMARY_COLOR,

    },
});
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);